export default function initializeWooForms() {
    initializeQuantityFields();
    autoUpdateCart();
    window.initializeQuantityFields= initializeQuantityFields;
}



function initializeQuantityFields() {
    let quantityFields = document.querySelectorAll('.quantity .qty');

    quantityFields.forEach((item) => {
        initializeQuantityField(item);
    });
}

const initializeQuantityField = (item) => {
    let subButton = document.createElement('div'),
        addButton = document.createElement('div');

    subButton.className = 'quantity__button quantity__button--sub';
    subButton.textContent = '-';
    addButton.className = 'quantity__button quantity__button--add';
    addButton.textContent = '+';

    item.parentNode.insertBefore(subButton, item);
    item.parentNode.insertBefore(addButton, item.nextSibling);


    subButton.addEventListener('click', (e) => {
        e.preventDefault();

        let value = parseInt(item.value);

        if (value > 1) {
            item.value = value - 1;
            possiblyUnlockUpdateCartButton();
        }
    });

    addButton.addEventListener('click', (e) => {
        e.preventDefault();
        item.value = parseInt(item.value) + 1;
        possiblyUnlockUpdateCartButton();
    });
}

const possiblyUnlockUpdateCartButton = () => {
    let updateButton = document.querySelector('.woocommerce-cart-form button[name="update_cart"]')

    if (updateButton) {
        updateButton.removeAttribute('disabled')
        updateButton.setAttribute('aria-disabled', 'false');
    }
}

const autoUpdateCart = () => {
    var timeout;

    document.querySelectorAll( '.woocommerce input.qty' ).forEach( function( input ) {
        input.addEventListener( 'change', function( e ) {
            if (timeout !== undefined) {
                clearTimeout( timeout );
            }
            timeout = setTimeout( function() {
                document.querySelector( '[name="update_cart"]' ).click(); // trigger cart update
            }, 800 ); // 1 second delay, half a second (500) seems comfortable too
        } );
    } );

    document.addEventListener( 'click', function( e ) {
        if (e.target.classList.contains( 'quantity__button' )) {
            if (timeout !== undefined) {
                clearTimeout( timeout );
            }
            timeout = setTimeout( function() {
                document.querySelector( '[name="update_cart"]' ).click(); // trigger cart update
            }, 800 ); // 1 second
        }
    } );
}